import { createSlice } from "@reduxjs/toolkit";
import { showDepartment } from "../actions";

const initialState = {
  department: [],
};

const departmentSlice = createSlice({
  name: "department",
  initialState,
  reducers: {},
  extraReducers: {
    [showDepartment.fulfilled]: (state, action) => {
      state.department = action.payload || [];
    },
  },
});

export const responseDepartment = (state) => state.department;

export default departmentSlice.reducer;
